<dx-popup
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [width]="'60%'"
  [height]="'auto'"
  [maxHeight]="'85vh'"
  [resizeEnabled]="true"
  [showCloseButton]="false">

  <div *dxTemplate="let _ of 'title'" class="dialog-header">

    <div class="dialog-title">
      <i class="fas fa-pencil-alt"></i>
      <strong>{{ dialogTitle() }}</strong>
    </div>

    <div class="dialog-actions">
      <yo-button
        iconClass="fas fa-save"
        tooltip="Appliquer"
        [theme]="ButtonThemeEnum.SAVE"
        (onClick)="save()">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        tooltip="Fermer"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="closeDialog()">
      </yo-button>
    </div>

  </div>

  <section class="dialog-content">

    <div class="dialog-column">
      <span class="dialog-section-title">
        <strong>Jours ouvrés</strong>
      </span>
      <div class="dialog-section-body">
        <yo-tree-list
          #treeListJours
          [data]="joursSemaine()"
          [returnData]="true"
          key="value"
          displayValue="viewValue"
          mode="list"
          (onValueChange)="onChangeJoursSemaine($event)">
        </yo-tree-list>
      </div>
    </div>

    <div class="dialog-column">

      <span class="dialog-section-title">
        <strong>Repas et régimes</strong>
      </span>
      <div class="dialog-section-body">
        <yo-tree-list
          #treeListRepas
          [data]="repas()"
          [returnData]="true"
          key="id"
          displayValue="libelle"
          childValue="children"
          mode="groupedList"
          (onValueChange)="onChangeRepasRegime($event)">
        </yo-tree-list>
      </div>
    </div>

    <div class="dialog-column">

      <span class="dialog-section-title">
        <strong>{{ fieldLabel() }}</strong>
      </span>

      <div class="dialog-section-body">
        <div class="dialog-input-row">
          <dx-number-box
            [value]="inputValue()"
            (valueChange)="inputValue.set($event)"
            [showSpinButtons]="true"
            width="100%">
          </dx-number-box>
          <span class="dialog-unit">{{ fieldUnit() }}</span>
        </div>
      </div>
    </div>
  </section>
</dx-popup>
